<template>
  <div class="NewVersion" v-if="false && judgeSwitch">
    <div
      class="closeBtn el-icon-close"
      @click="
        clickToClose();
        materialPushAnalysis({type: 'NewVersionClose'});
      "
    ></div>

    <div
      class="versionUpdate"
      v-if="this.UserMsg.versionUpdate && this.UserMsg.versionData.updataMessage"
      @click="
        stepFS(2);
        materialPushAnalysis({type: 'NewVersionOn'});
      "
    >
      <span class="bdbt">{{ this.UserMsg.versionData.updataMessage }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Analysis from './mixins/analysis/materialBu'
export default {
  mixins: [Analysis],
  data() {
    return {
      judgeSwitch: false,
    }
  },
  computed: {
    ...mapGetters([
      'UserMsg'
    ])
  },
  props: [ 'allFormJson'],
  watch : {
    'UserMsg.versionNumber' : function(val, oldval){ // 加载完成
      // if(this.allFormJson){

        if(this.UserMsg.versionNumber > 400 && this.UserMsg.versionNumber < this.UserMsg.versionTOOL){

          if(this.UserMsg.versionUpdate && this.UserMsg.versionData.updataMessage){

            this.judgeSwitch = true;
            this.$bus.emit('touchGuidance_vue');
          }
        }
      // }
    },
  },
  created () {
    this.$bus.on('Guidance.closed', this.onGuidanceClosed);
  },
  beforeDestroy () {
    this.$bus.off('Guidance.closed', this.onGuidanceClosed);
  },
  mounted() {
  },
  methods: {
    stepFS(data){
      switch(data){
        case 1:
          this.judgeSwitch = false;
          this.$bus.emit('touchGuidance_vue');
          break;
        case 2:
          this.openArticle();
      }
    },
    clickToClose () {
      this.judgeSwitch = false;
      this.$bus.emit('touchGuidance_vue', false);
    },
    openArticle () {
      const url = this.UserMsg.versionData.linkUrl //'https://mp.weixin.qq.com/s/Qr4MuMo1pZUxY5sXwXfmHg';
      $(`<a href="${url}" target="_blank"></a>`)[0].click();
    },
    onGuidanceClosed () {
      this.judgeSwitch = false;
    }
  }
}
</script>

<style lang="scss">
.NewVersion {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;

  .versionUpdate {
    width: 100%;
    height: 60px;
    color: #fff;
    line-height: 60px;
    background: rgba(87, 120, 251, .9);
    cursor: pointer;
  }
  .closeBtn {
    position: absolute;
    top: 0;
    right: 72px;
    bottom: 0;
    width: 20px;
    height: 20px;
    margin: auto;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
  }
}
.bdbt {
  &:hover {
    border-bottom: 1px solid #fff;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/NewVersion.vue